__turbopack_context__.v({
  "captionWithMB": "styleConstants-module__spec_W__captionWithMB",
  "h1": "styleConstants-module__spec_W__h1",
  "h2": "styleConstants-module__spec_W__h2",
  "sectionPadding": "styleConstants-module__spec_W__sectionPadding",
  "subtitle": "styleConstants-module__spec_W__subtitle",
});
